<template>
  <header class="admin-start-hub__orient">
    <div class="admin-start-hub__brand">
      <div class="admin-start-hub__logo" aria-hidden="true">
        <i class="fa fa-music"></i>
      </div>
      <div>
        <h1 class="admin-start-hub__greeting">{{ greeting }}</h1>
        <p class="admin-start-hub__meta">
          <template v-if="roleLine">{{ roleLine }}</template>
          <template v-if="roleLine && orient.account_name"> · </template>
          <template v-if="orient.account_name">{{ orient.account_name }}</template>
        </p>
      </div>
    </div>
    <p class="admin-start-hub__date">{{ orient.date_label }}</p>
  </header>
</template>

<script>
export default {
  name: 'StartHubOrient',
  props: {
    orient: { type: Object, required: true },
    greetingTemplate: { type: String, required: true },
  },
  computed: {
    greeting() {
      const name = this.orient.first_name || this.orient.user_name || '';
      return this.greetingTemplate.replace(':name', name);
    },
    roleLine() {
      const roles = Array.isArray(this.orient.roles) ? this.orient.roles : [];
      return roles.join(' · ');
    },
  },
};
</script>
